<template>
  <div class="content">
    <navBar></navBar>
    <div class="top-box">
      <div class="title-box justify-align">
        <span>数字营销</span>
        <van-icon name="arrow" />
      </div>
       <div class="top-bottom-box justify-align">
         <div class="item">
           <span class="name">总销售额</span>
           <b>￥555.00</b>
           <div class="des">昨日￥20.33</div>
         </div>
         <div class="item">
           <span class="name">总订单数</span>
           <b>20</b>
           <div class="des">昨日5</div>
         </div>
         <div class="item">
           <span class="name">总用户数</span>
           <b>￥555.00</b>
           <div class="des">昨日8</div>
         </div>
       </div>
    </div>
    <div class="shop-box top-box">
      <div class="shop-title-box">
        <span class="title">门店商品</span>
        <div class="shop-des-box justify-align">
          <div class="shop-des-lf">
            <b>8</b>
            <div class="des">销售中<van-icon name="arrow" /></div>
          </div>
          <div class="shop-des-lf">
            <b>8</b>
            <div class="des">待上架<van-icon name="arrow" /></div>
          </div>
        </div>
      </div>
      <div class="shop-goods-box">
        <div class="shop-one">爆款Top1</div>
        <div class="goods-box">
          <div class="goods-item left-justifying">
            <img src="" alt="" />
            <div class="goods-title">
              标题标题标题标题标题
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sales-box">
      <div class="sales-title">
        营销工具 <span>没有优质的货源也能轻松赚钱</span>
      </div>
      <div class="sales-list">
        <div class="sales-item-box justify-align">
          <div class="sales-item">权限管理</div>
          <div class="sales-item">通知管理</div>
        </div>
        <div class="sales-item-box justify-align">
          <div class="sales-item">申请收款码</div>
          <div class="sales-item">申请T+0结算</div>
        </div>
        <div class="sales-item-box justify-align">
          <div class="sales-item">发放优惠券</div>
          <div class="sales-item">发放代金券</div>
        </div>
        <div class="sales-item-box justify-align">
          <div class="sales-item">申请成为中山手信</div>
          <div class="sales-item">申请直播带货</div>
        </div>
        <div class="sales-item sales-item-sec">申请制作VR工厂、VR产品（元宇宙）</div>
        <div class="sales-item-box justify-align">
          <div class="sales-item">申请名人探厂</div>
          <div class="sales-item">申请博览中心展位</div>
        </div>
        <div class="sales-item sales-item-sec">申请广东省名优品牌企业（免费）</div>
      </div>
    </div>
    <div class="null-box"></div>
    <businessTabbar />
  </div>

</template>

<script>
import businessTabbar from "@/components/businessTabbar";
import navBar from "@/components/navBar";
export default {
  name: "indexBusiness",
  data(){
    return{
      login: 1  // 0显示登陆 1隐藏
    }
  },
  components: {
    businessTabbar,
    navBar
  },

}
</script>

<style lang="scss" scoped>
.top-box{
  margin: 20px 24px 20px;
  background: #FFFFFF;border-radius: 30px;
  .title-box{
    padding: 20px;font-weight:bold;font-size: 30px;
  }
  .top-bottom-box{
    padding: 30px 60px 40px;
    .item{
      .name{
        display: block;
      }
      b{
        font-size: 32px;display: block;margin-top: 20px;margin-bottom: 20px;
      }
      .des{
        color: #999999;font-size: 26px;
      }
    }
  }
}
.shop-box{
 .shop-title-box{
   padding: 20px 20px;
   .title{
     font-weight: bold;font-size: 30px;
   }
   .shop-des-box{
     padding: 20px 60px;margin-top: 20px;
      .shop-des-lf{
        text-align: center;
        color: #999999;font-size: 26px;
        b{
          font-size: 53px;color: #282828;display: block;
          margin-bottom:10px;
        }
      }
   }
 }
  .shop-goods-box{
    padding:0 20px 20px;
    .shop-one{
      padding: 20px 0;
    }
    .goods-box{
      .goods-item{
        img{
          width: 130px;height: 130px;
        }
        .goods-title{
          width: 500px;margin-left: 10px;
          ext-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
.sales-box{
  margin: 20px 24px 20px;
  background: #FFFFFF;border-radius: 30px;
  .sales-title{
    padding: 20px;font-size: 30px;font-weight: bold;
    span{
      color: #999999;font-size: 26px;
    }
  }
  .sales-list{
    padding: 10px 20px 30px;
    .sales-item-box{
      margin-bottom: 15px;

    }
    .sales-item{
      width: 49%;text-align: center;background: #f2f2f2;padding: 20px 0;
    }
    .sales-item-sec{
      width: 100%; margin-bottom: 15px;
    }
  }
}
</style>
